<ifc-base-dialog title="Set filter"
                 [actions]="actions"
                 (actionClicked)="onActionClicked($event)">
  <ng-template #content>
    <div class="container" [class.single-column]="isSingle">
      <ng-content></ng-content>
    </div>
  </ng-template>
</ifc-base-dialog>
